import { FormLabel } from "../ui/form";

export const EmptyFormLabel = () => <FormLabel>{` `}</FormLabel>
